module.exports = __webpack_public_path__ + "img/t5-5.d750510a.svg";